const Exposicao_Design = [

  /*
  {
    title: "Pormade Portas Showroom de materiais e equipamentos",
    instructor: "",
    institution: "PUC Goiás",
    desc: `Independente de onde você estiver, a Pormade vai até você! O projeto do Pormade Móvel tem como objetivo divulgar os produtos e serviços da empresa além das barreiras geográficas. O veículo passa por eventos de inúmeras cidades para que a comunidade local possa conhecer de perto o que a Pormade oferece ao mercado.

    O primeiro Showroom Móvel da Pormade estreou na “Feicon Batimat em 2019, depois dos comentários positivos sobre a novidade, a frota cresceu e os veículos passaram por vários eventos importantes e tradicionais de diferentes cidades, como Design Fair, Expoingá, Kiwi Fest, Feicon, High Design, Equipotel, ConstruSul, lojas de materiais de construção, entre outros.
    
    Ele apresenta em sua carroceria os modelos de portas da Pormade, as estampas dos papéis de parede, piso vinilico, rodapés e fechaduras. Além disso, mesas e cadeiras ficam dispostas próximas aos veículos para que os visitantes conversem com os especificadores e analisem os catálogos.
    
    A arquitetura dos veículos do projeto conta ainda com uma televisão, na qual vídeos sobre a cultura Pormade são exibidos durante as participações nas feiras.
    
    O Pormade Móvel participa de vários eventos, feiras e faz visitas aos seus parceiros como lojas, arquitetos, engenheiros e instaladores.
    `,
    
    date: "09/05/2023",
    time: "08:00-11:30",
    place: "Próximo ao Teatro de Arena da área III",
    image: "assets/img/slider/expo_pormade.png"
  },
  */
]

const Exposicao_Arquitetura = [
  {
    title: "Lançamento do livro Pessoalidades",
    instructor: "Frederico André Rabelo",
    desc: `Lançamento e discussão sobre o livro que será lançado.`,
    date: "18/04/2024 (Quinta)",
    time: "18:00",
    place: "Auditório 2, área II",
    image: "assets/img/slider/Capa_do_livro_FREDERICO_ANDRE_RABE.jpeg"
  },



  /*
  {
    title: "TFC1 - Trabalho de Fim de Ciclo 1 do curso de Arquitetura e Urbanismo",
    instructor: "",
    institution: "PUC Goiás",
    desc: `Exposição dos trabalhos de TFC -1 | Trabalho de Fim de Ciclo 1, apresentados em 2022/2.
    O TFC-1 é uma atividade prevista no Projeto Pedagógico do Curso de Arquitetura e Urbanismo no encerramento do Primeiro Ciclo de Aprendizagem, que se inicia no 1º período e finaliza no 3º período, para o turno matutino, e 4º período, para o turno noturno. Consiste em um projeto integrado que contempla a aplicação dos conteúdos das disciplinas que compõem esse ciclo.
    `,
    
    date: "08 a 10/05",
    time: "07:15-22:00",
    place: "Foyer dos auditórios 2 e 3 na área II",
    image: "assets/img/slider/oficina_FREDERICO_ANDRE_RABE.jpg"
  },

  {
    title: "Pizzada",
    instructor: "",
    institution: "PUC Goiás",
    desc: `Evento de produção de pizzas elaboradas pelos alunos do C.A. de Arquitetura e Urbanismo, e o Prof. Carlos Vaz de Campos`,
    
    date: "09/05/2023",
    time: "18:00",
    place: "Anfiteatro da área III",
    image: "assets/img/slider/expo_pizzada.jpg"
  },

  {
    title: "Publicação",
    instructor: "Ana Carolina Amaral Marques e Solange da Silva",
    institution: "PUC Goiás",
    desc: `Publicação do livro : Planejamento e controle de obra integrado ao BIM, com foco no processo de conhecimento`,
    
    date: "09/05",
    time: "19:00",
    place: "Auditório Marisa Roriz (Área III)",
    image: "assets/img/slider/Livro_Ana_Carolina.png"
  },
  */
]


export const Exposicao_Cursos = [
  {
    curso: 'Design',
    exposicoes: Exposicao_Design,
  },
  {
    curso: 'Arquitetura',
    exposicoes: Exposicao_Arquitetura,
  },
  
]